export default __webpack_public_path__ + "static/media/user.c2876ea8.png";